import React, { MouseEvent, SyntheticEvent } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Button } from '@daedalus/atlas/Button';
import { Flag } from '@daedalus/atlas/Flag';
import { getCountryCodeFromLanguage } from '@daedalus/core/src/localization/services/country';
import { SelectedElement } from '..';
interface Props {
  currency: string;
  language: string;
  hasCurrency?: boolean;
  hasLanguage?: boolean;
  onClick: (element: SelectedElement) => void;
}
const CurrencyWrapper = /*#__PURE__*/styled('span')({
  name: "CurrencyWrapper",
  class: "cqklf2p",
  propsAsIs: false
});
const LanguageWrapper = /*#__PURE__*/styled('span')({
  name: "LanguageWrapper",
  class: "l1nk96x2",
  propsAsIs: false
});
export const PreferencesLink = ({
  currency,
  language,
  hasLanguage = true,
  hasCurrency = true,
  onClick
}: Props) => {
  const countryCode = getCountryCodeFromLanguage(language);
  const handleClicked = (event: MouseEvent | SyntheticEvent, element: SelectedElement) => {
    event.stopPropagation();
    onClick(element);
  };
  return <Button dataId="PreferencesSelectorButton" size="md" variant="quiet" onClick={event => handleClicked(event, hasLanguage ? 'language' : 'currency')} iconStart={<>
          {hasLanguage && <LanguageWrapper data-id="language" data-language={language} onClick={event => handleClicked(event, 'language')}>
              <Flag countryCode={countryCode} />
            </LanguageWrapper>}
          {hasCurrency && <CurrencyWrapper data-id="currency" onClick={event => handleClicked(event, 'currency')} translate="no" className={cx(hasLanguage && 'hasLanguage')}>
              {currency}
            </CurrencyWrapper>}
        </>} />;
};

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");